var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12",
    width: 16,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "right-arrow-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 12,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAAXNSR0IB2cksfwAAAVBQTFRF/vz9//3+//7/9f//8+iwyJ5i+M61//zz7vz8/v/9/P//+///9/3z//jxyahjt5w17Nut//39/v3///f////0///z//72/PDIx7tns6lI7OCs//34+f3/+v7///v/8PT1+/7///b/v690uKdV3NOo/v/v//vs//z//Pz8//z4//Lp2LF4uqFR8OG62LNl065gzahayaRWyqVXzKdZw6NYxbFotaxRt6hD4btw26duwpNFwp4w17BV0qtQzaZLy6RJzKVKzqdMwaRgvqtNx7lguapLvKo6yaVXy6BcxJ0k//rz//P+//j///v7///ozMV9rZpN/te2////9f/z+v7n//r6ybNnxJ9E7NOy+f////38+f/9+Pbn07mEu5xJ696n//74/vb///r//Pjvuq12uZpK8teo///29Pz///3//+fJxJ5J69SQ/vT////49P/+n3zlXwAAAHB0Uk5TAAAAAPn/2QAAAAAAAAD///8AAAAAAABg////AAAAAAAAAP///wAAAAAAAP//uf////////////////////////////////////8AAAAAAP//0wAAAAD//+wAAAAA////AAAAAP///wAAAFr//wAAAKF9wmIAAABnSURBVHicXYwxEkAwFET/hsFEg6RUqtNqnMKxXUSFTmMyIV9+wSt2Zt/sLAigCJirgI4lECkkLA8CNst1RY89xJGRhaKXQYTj9Jl0TJzkcxHahOM56ZyIOX0Ay/gR1X/R/EXZAmcN3EzDEORQB8ZgAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "back-_1_",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.57d4b744b5a245b2e5ce15361aa31dfa.svg";
export { ForwardRef as ReactComponent };